import Vue from 'vue'
import Moment from 'moment'
import IdleVue from 'idle-vue'
import VueTheMask from 'vue-the-mask'
import VeeValidate from 'vee-validate'
import VueMomentLib from 'vue-moment-lib'

import store from '@/vuex'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import Snackbar from '@/plugins/snackbar/snackbar.js'
import { contrastHex } from '@/plugins/helpers'
import Confirm from '@/plugins/confirm/confirm.js'
import 'material-icons/iconfont/material-icons.css'

// External libraries
import { activateHotjar } from '@/external-libs/hotjar.js'

const eventsHub = new Vue()

Moment.locale('pt-BR')

Vue.use(VueMomentLib, { moment: Moment })
Vue.use(Confirm)
Vue.use(VueTheMask)
Vue.use(VeeValidate, { events: 'blur' })
Vue.use(Snackbar, { vuetify })
Vue.use(IdleVue, { eventEmitter: eventsHub, store, idleTime: 40000, startAtIdle: false })
Vue.prototype.$contrastHex = contrastHex

Vue.config.productionTip = false

/* External libraries */
if (process.env.NODE_ENV === 'production') {
  activateHotjar(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
